
riot.tag2('email-templates', '  <catalog object="EmailTemplate" cols="{cols}" reload="true" handlers="{handlers}" add="{permission(add, &quot;mails&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;mails&quot;, &quot;0001&quot;)}" dblclick="{permission(letterOpen, &quot;mails&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="title"><i class="fa {row.isActive ? &quot;fa-paper-plane&quot; : &quot;fa-paper-plane text-noactive&quot;}"></i> {row.title}</datatable-cell>\n      <datatable-cell name="mailtype">{row.mailtype}</datatable-cell>\n      <datatable-cell name="subject">{row.subject}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');

self.collection = 'EmailTemplate';

self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }, { name: 'itempost', value: 'Код' }, { name: 'subject', value: 'Тема' }];

self.add = function () {
    return riot.route('settings/email/new');
};

self.letterOpen = function (e) {
    return riot.route('settings/email/' + e.item.row.id);
};

observable.on('email-reload', function () {
    self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/settings/email/email-templates.tag